<template>
  <div class="brandIdBlock">
    <div class="brandId-row" v-for="shop in shopList" :key="shop.id">
      <el-image :src="shop.icon" style="width: 26px; height: 26px; border-radius: 50%"></el-image>
      <el-tooltip v-if="shop.channelIcon" :content="shop.channelName" style="margin: 0px -6px 0px 6px;">
        <el-image :src="shop.channelIcon" style="width: 18px; height: 18px;"></el-image>
      </el-tooltip>
      <span class="shop-title">{{ shop.shortTitle || shop.title }}</span>
      <el-select
        :value="valueMap[shop.id]"
        value-key="brandId"
        name-key="brandName"
        :loading="loading[shop.id]"
        clearable
        filterable
        remote
        :remote-method="($event) => remoteMethod($event, shop.id)"
        @visible-change="isShow => visibleSelect(isShow, shop.id)"
        @change="v => selectChange(v, shop.id)"
      >
        <el-option v-for="brandOp in brandOptions[shop.id]" :key="brandOp.brandId" :label="brandOp.brandName" :value="brandOp"> </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { queryBrandList } from '@/servers/prod/center/xhs.js';

import _ from 'lodash';
export default {
  name: 'BrandIdBlock',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    shopList: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    categoryIds: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      valueMap: {},
      brandOptions: {},
      loading: {},
      getFail: {},
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.valueMap = {};
        if (v && v.length) {
          v.forEach(item => {
            const { shopId, brandId, brandName } = item || {};
            if (shopId && brandId) {
              this.$set(this.valueMap, shopId, item);

              !brandName && this.getBrandList(shopId);
            }
          });
        }
      },
    },
    categoryIds: {
      immediate: true,
      handler(v) {
        this.brandOptions = {};
      },
    },
  },
  methods: {
    visibleSelect(isShow, shopId) {
      if (!isShow) return;
      if (!this.brandOptions[shopId]?.length) {
        this.getBrandList(shopId);
      }
    },
    selectChange(v, shopId) {
      this.valueMap[shopId] = v;
      this.valueChange();
    },
    valueChange() {
      const brandList = Object.values(this.valueMap).filter(Boolean).map(item => {
        return {
          ...item,
          channel: this.shopList.find(shop => shop.id == item.shopId)?.channel
        }
      });
      this.$emit('change', brandList);
    },
    remoteMethod(query, shopId) {
      this.getBrandList(shopId, query);
    },
    // 获取品牌
    async getBrandList(shopId, query) {
      try {
        let categoryIds = this.categoryIds || [];
        if (categoryIds.length) {
          let params = {
            shopId,
            categoryLeafId: categoryIds[categoryIds.length - 1],
            pageNumber: 1,
            pageSize: 50,
            keyword: query || '',
          };
          this.$set(this.loading, shopId, true);
          const res = await queryBrandList(params);
          this.loading[shopId] = false;
          let brands = res.data?.brands || [];
          const list = brands.map(item => {
            return {
              shopId,
              brandId: item.id * 1,
              brandName: item.name,
            };
          });
          if (this.valueMap[shopId]) {
            const findItem = list.find(item => item.brandId === this.valueMap[shopId].brandId);
            if (!findItem) {
              this.valueMap[shopId] = null;
              this.valueChange();
            } else if (!this.valueMap[shopId].brandName) {
              this.valueMap[shopId].brandName = findItem.brandName;
              this.valueChange();
            }
          }

          this.$set(this.brandOptions, shopId, list);
        }
      } catch (error) {
        console.log(error, '-----error');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.brandId-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>